import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';
import * as moment from 'moment';


/**
 * Generated class for the EditprivPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-editpriv',
  templateUrl: 'editpriv.html',
})
export class EditprivPage {
  User: any
  userNo = 0;

  privfm = false
  privfmcurrentmileage = false
  privfmcosts = false
  privfmeditcosts = false

  privlivetracking = false
  privaddpoi = false
  privviewpoi = false
  privaddzones = false
  privviewzones = false
  privlivemoreoptions = false

  privreports = false
  privdashboard = false
  privoverview = false
  privshortreport = false
  //new
  privelectricvehrep = false
  privvozenparkreport = false
  privdrivervehicle = false
  privbaddrivingvehilce = false
  privtrafficrules = false
  privinterventionreport = false
  privmovementsensor = false
  privtowreport = false
  privdigalkaanalog = false
  privsecurityprotocol = false
  privcbfueladded = false
  privweaksatellites = false
  privagrreport = false
  privtaxi1report = false
  privtaxi2report = false
  privspeedlimitbuzzer = false
  privdraegerdatarep = false
  privsumdataroutingvehicles = false
  privsumdataroutingdrivers = false
  privroutingunvisitedpoi = false
  privshiftoverview = false
  privdriverreport = false
  privdriveranalytics = false
  privdriverscore = false
  privcustomizedreport = false
  privrfiddriver = false
  privprotocolgenerator = false
  privgarminmessages = false
  privgarminstopstatus = false
  //end new
  privdetailreport = false
  prividlingreport = false
  privworktimereport = false
  privvisitedpoi = false
  privreconstruction = false
  privdistance = false
  privactivity = false
  privmaxspeed = false
  privspeedlimit = false
  privfuelreport = false
  privfmoverview = false
  privfmreportcosts = false
  privfmreportfuel = false
  privfmreportperformed = false
  privfmothercosts = false
  privfmfullreport = false
  privfmalerttires = false
  privfmalertservice = false
  privfmalertreg = false
  privalarmreport = false
  privexportpdf = false
  privexportexcel = false
  privschedule = false

  privsettings = false
  privgeneralsettings = false
  privusersettings = false
  privgroupspoi = false
  privvehicles = false
  privounits = false
  privemployees = false
  privworktime = false // settings work schedule
  privnonworkingdays = false
  privalerts = false

  privroutes = false
  privroutesnew = false
  privroutespredefined = false
  privroutessearch = false
  privlogsreport = false
  privjobs = false
  privarmament = false
  privarmdisarm = false
  privfuelpulses = false
  privsecuritystatereport = false
  privtechmalreport = false
  privsummdatarouting = false

  privbeaconreport = false
  privbluethoottemp = false
  privsusfueldown = false
  privtachogram = false
  privbarcodescanner = false


  // this.gn.clientsettings.hasallcan300 


  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN) {
    this.User = this.navParams.get('user')
    if (this.gn.user.RoleId == 3)
      this.userNo = 0;
    else {
      for (var i = 0; i < this.gn.priv.length; i++) {
        if (this.User.id == this.gn.priv[i].userid) {
          this.userNo = i
        }
      }
    }

    this.privfm = this.gn.priv[this.userNo].fm;
    this.privfmcurrentmileage = this.gn.priv[this.userNo].fmcurrentmileage;
    this.privfmcosts = this.gn.priv[this.userNo].fmcosts;
    this.privfmeditcosts = this.gn.priv[this.userNo].fmeditcosts;
    this.privarmdisarm = this.gn.priv[this.userNo].armdisarm;

    this.privlivetracking = this.gn.priv[this.userNo].livetracking;
    this.privaddpoi = this.gn.priv[this.userNo].addpoi;
    this.privviewpoi = this.gn.priv[this.userNo].viewpoi;
    this.privaddzones = this.gn.priv[this.userNo].addzones;
    this.privviewzones = this.gn.priv[this.userNo].viewzones;
    this.privlivemoreoptions = this.gn.priv[this.userNo].livemoreoptions;

    this.privreports = this.gn.priv[this.userNo].reports;
    this.privdashboard = this.gn.priv[this.userNo].dashboard;
    this.privoverview = this.gn.priv[this.userNo].overview;
    this.privshortreport = this.gn.priv[this.userNo].shortreport;
    //new
    this.privelectricvehrep = this.gn.priv[this.userNo].electricvehrep
    this.privvozenparkreport = this.gn.priv[this.userNo].vozenparkreport
    this.privdrivervehicle = this.gn.priv[this.userNo].drivervehicle
    this.privbaddrivingvehilce = this.gn.priv[this.userNo].baddrivingvehicle
    this.privtrafficrules = this.gn.priv[this.userNo].trafficrules
    this.privinterventionreport = this.gn.priv[this.userNo].interventionreport
    this.privmovementsensor = this.gn.priv[this.userNo].movementsensor
    this.privtowreport = this.gn.priv[this.userNo].towreport
    this.privdigalkaanalog = this.gn.priv[this.userNo].digalkaanalog
    this.privsecurityprotocol = this.gn.priv[this.userNo].securityprotocol
    this.privcbfueladded = this.gn.priv[this.userNo].cbfueladded
    this.privweaksatellites = this.gn.priv[this.userNo].weaksatellites
    this.privagrreport = this.gn.priv[this.userNo].agrreport
    this.privtaxi1report = this.gn.priv[this.userNo].taxi1report
    this.privtaxi2report = this.gn.priv[this.userNo].taxi2report
    this.privspeedlimitbuzzer = this.gn.priv[this.userNo].speedlimitbuzzerrep
    this.privdraegerdatarep = this.gn.priv[this.userNo].draegerdatarep
    this.privsumdataroutingvehicles = this.gn.priv[this.userNo].sumdataroutingvehicles
    this.privsumdataroutingdrivers = this.gn.priv[this.userNo].sumdataroutingdrivers
    this.privroutingunvisitedpoi = this.gn.priv[this.userNo].routingunvisitedpoi
    this.privshiftoverview = this.gn.priv[this.userNo].shiftoverview
    this.privdriverreport = this.gn.priv[this.userNo].driverreport
    this.privdriveranalytics = this.gn.priv[this.userNo].driveranalytics
    this.privdriverscore = this.gn.priv[this.userNo].driverscore
    this.privcustomizedreport = this.gn.priv[this.userNo].customizedreport
    this.privrfiddriver = this.gn.priv[this.userNo].rfiddriver
    this.privprotocolgenerator = this.gn.priv[this.userNo].protocolgenerator
    this.privgarminmessages = this.gn.priv[this.userNo].garminmessages
    this.privgarminstopstatus = this.gn.priv[this.userNo].garminstopstatus

    //end new
    this.privdetailreport = this.gn.priv[this.userNo].detailreport;
    this.prividlingreport = this.gn.priv[this.userNo].idlingreport;
    this.privworktimereport = this.gn.priv[this.userNo].worktimereport;
    this.privvisitedpoi = this.gn.priv[this.userNo].visitedpoi;
    this.privreconstruction = this.gn.priv[this.userNo].reconstruction;
    this.privdistance = this.gn.priv[this.userNo].distance;
    this.privactivity = this.gn.priv[this.userNo].activity;
    this.privmaxspeed = this.gn.priv[this.userNo].maxspeed;
    this.privspeedlimit = this.gn.priv[this.userNo].speedlimit;
    this.privfuelreport = this.gn.priv[this.userNo].fuelreport;
    this.privfmoverview = this.gn.priv[this.userNo].fmoverview;
    this.privfmreportcosts = this.gn.priv[this.userNo].fmreportcosts;
    this.privfmreportfuel = this.gn.priv[this.userNo].fmreportfuel;
    this.privfmreportperformed = this.gn.priv[this.userNo].fmreportperformed;
    this.privfmothercosts = this.gn.priv[this.userNo].fmothercosts;
    this.privfmfullreport = this.gn.priv[this.userNo].fmfullreport;
    this.privfmalerttires = this.gn.priv[this.userNo].fmalerttires;
    this.privfmalertservice = this.gn.priv[this.userNo].fmalertservice;
    this.privfmalertreg = this.gn.priv[this.userNo].fmalertreg;
    this.privalarmreport = this.gn.priv[this.userNo].alarmreport;
    this.privexportpdf = this.gn.priv[this.userNo].exportpdf;
    this.privexportexcel = this.gn.priv[this.userNo].exportexcel;
    this.privschedule = this.gn.priv[this.userNo].schedule;
    this.privfuelpulses = this.gn.priv[this.userNo].fuelpulses;
    this.privsecuritystatereport = this.gn.priv[this.userNo].securitystatereport;
    this.privtechmalreport = this.gn.priv[this.userNo].techmalreport;
    this.privsummdatarouting = this.gn.priv[this.userNo].summdatarouting
    this.privbeaconreport = this.gn.priv[this.userNo].beaconreport
    this.privbluethoottemp = this.gn.priv[this.userNo].bluethoottemp
    this.privsusfueldown = this.gn.priv[this.userNo].susfueldown
    this.privtachogram = this.gn.priv[this.userNo].tachogram






    this.privsettings = this.gn.priv[this.userNo].settings;
    this.privgeneralsettings = this.gn.priv[this.userNo].generalsettings;
    this.privusersettings = this.gn.priv[this.userNo].usersettings;
    this.privgroupspoi = this.gn.priv[this.userNo].groupspoi;
    this.privvehicles = this.gn.priv[this.userNo].vehicles;
    this.privounits = this.gn.priv[this.userNo].ounits;
    this.privemployees = this.gn.priv[this.userNo].employees;
    this.privworktime = this.gn.priv[this.userNo].worktime; // settings work schedule
    this.privnonworkingdays = this.gn.priv[this.userNo].nonworkingdays;
    this.privalerts = this.gn.priv[this.userNo].alerts;
    this.privlogsreport = this.gn.priv[this.userNo].logsreport;
    this.privjobs = this.gn.priv[this.userNo].jobs;
    this.privarmament = this.gn.priv[this.userNo].armament;

    this.privroutes = this.gn.priv[this.userNo].routes;
    this.privroutesnew = this.gn.priv[this.userNo].routesnew;
    this.privroutespredefined = this.gn.priv[this.userNo].routespredefined;
    this.privroutessearch = this.gn.priv[this.userNo].routessearch;

    this.privbarcodescanner = this.gn.priv[this.userNo].barcodescanner;


  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EditprivPage');
  }

  Save() {
    var _that = this

    this.gn.priv[this.userNo].fm = this.privfm;
    this.gn.priv[this.userNo].fmcurrentmileage = this.privfmcurrentmileage;
    this.gn.priv[this.userNo].fmcosts = this.privfmcosts;
    this.gn.priv[this.userNo].fmeditcosts = this.privfmeditcosts;
    this.gn.priv[this.userNo].armdisarm = this.privarmdisarm;

    this.gn.priv[this.userNo].livetracking = this.privlivetracking;
    this.gn.priv[this.userNo].addpoi = this.privaddpoi;
    this.gn.priv[this.userNo].viewpoi = this.privviewpoi;
    this.gn.priv[this.userNo].addzones = this.privaddzones;
    this.gn.priv[this.userNo].viewzones = this.privviewzones;
    this.gn.priv[this.userNo].livemoreoptions = this.privlivemoreoptions;

    this.gn.priv[this.userNo].reports = this.privreports;
    this.gn.priv[this.userNo].dashboard = this.privdashboard;
    this.gn.priv[this.userNo].overview = this.privoverview;
    this.gn.priv[this.userNo].shortreport = this.privshortreport;
    //new
    this.gn.priv[this.userNo].electricvehrep = this.privelectricvehrep;
    this.gn.priv[this.userNo].vozenparkreport = this.privvozenparkreport;
    this.gn.priv[this.userNo].drivervehicle = this.privdrivervehicle;
    this.gn.priv[this.userNo].baddrivingvehicle = this.privbaddrivingvehilce;
    this.gn.priv[this.userNo].trafficrules = this.privtrafficrules;
    this.gn.priv[this.userNo].interventionreport = this.privinterventionreport;
    this.gn.priv[this.userNo].movementsensor = this.privmovementsensor;
    this.gn.priv[this.userNo].towreport = this.privtowreport;
    this.gn.priv[this.userNo].digalkaanalog = this.privdigalkaanalog;
    this.gn.priv[this.userNo].securityprotocol = this.privsecurityprotocol;
    this.gn.priv[this.userNo].cbfueladded = this.privcbfueladded;
    this.gn.priv[this.userNo].weaksatellites = this.privweaksatellites;
    this.gn.priv[this.userNo].agrreport = this.privagrreport;
    this.gn.priv[this.userNo].taxi1report = this.privtaxi1report;
    this.gn.priv[this.userNo].taxi2report = this.privtaxi2report;
    this.gn.priv[this.userNo].speedlimitbuzzerrep = this.privspeedlimitbuzzer;
    this.gn.priv[this.userNo].draegerdatarep = this.privdraegerdatarep;
    this.gn.priv[this.userNo].sumdataroutingvehicles = this.privsumdataroutingvehicles;
    this.gn.priv[this.userNo].sumdataroutingdrivers = this.privsumdataroutingdrivers;
    this.gn.priv[this.userNo].routingunvisitedpoi = this.privroutingunvisitedpoi;
    this.gn.priv[this.userNo].shiftoverview = this.privshiftoverview;
    this.gn.priv[this.userNo].driverreport = this.privdriverreport;
    this.gn.priv[this.userNo].driveranalytics = this.privdriveranalytics;
    this.gn.priv[this.userNo].driverscore = this.privdriverscore;
    this.gn.priv[this.userNo].customizedreport = this.privcustomizedreport;
    this.gn.priv[this.userNo].rfiddriver = this.privrfiddriver;
    this.gn.priv[this.userNo].protocolgenerator = this.privprotocolgenerator;
    this.gn.priv[this.userNo].garminmessages = this.privgarminmessages;
    this.gn.priv[this.userNo].garminstopstatus = this.privgarminstopstatus;

    //end new
    this.gn.priv[this.userNo].detailreport = this.privdetailreport;
    this.gn.priv[this.userNo].idlingreport = this.prividlingreport;
    this.gn.priv[this.userNo].worktimereport = this.privworktimereport;
    this.gn.priv[this.userNo].visitedpoi = this.privvisitedpoi;
    this.gn.priv[this.userNo].reconstruction = this.privreconstruction;
    this.gn.priv[this.userNo].distance = this.privdistance;
    this.gn.priv[this.userNo].activity = this.privactivity;
    this.gn.priv[this.userNo].maxspeed = this.privmaxspeed;
    this.gn.priv[this.userNo].speedlimit = this.privspeedlimit;
    this.gn.priv[this.userNo].fuelreport = this.privfuelreport;
    this.gn.priv[this.userNo].fmoverview = this.privfmoverview;
    this.gn.priv[this.userNo].fmreportcosts = this.privfmreportcosts;
    this.gn.priv[this.userNo].fmreportfuel = this.privfmreportfuel;
    this.gn.priv[this.userNo].fmreportperformed = this.privfmreportperformed;
    this.gn.priv[this.userNo].fmothercosts = this.privfmothercosts;
    this.gn.priv[this.userNo].fmfullreport = this.privfmfullreport;
    this.gn.priv[this.userNo].fmalerttires = this.privfmalerttires;
    this.gn.priv[this.userNo].fmalertservice = this.privfmalertservice;
    this.gn.priv[this.userNo].fmalertreg = this.privfmalertreg;
    this.gn.priv[this.userNo].alarmreport = this.privalarmreport;
    this.gn.priv[this.userNo].exportpdf = this.privexportpdf;
    this.gn.priv[this.userNo].exportexcel = this.privexportexcel;
    this.gn.priv[this.userNo].schedule = this.privschedule;
    this.gn.priv[this.userNo].fuelpulses = this.privfuelpulses;
    this.gn.priv[this.userNo].securitystatereport = this.privsecuritystatereport;
    this.gn.priv[this.userNo].techmalreport = this.privtechmalreport;
    this.gn.priv[this.userNo].summdatarouting = this.privsummdatarouting;
    this.gn.priv[this.userNo].beaconreport = this.privbeaconreport;
    this.gn.priv[this.userNo].bluethoottemp = this.privbluethoottemp;
    this.gn.priv[this.userNo].susfueldown = this.privsusfueldown;
    this.gn.priv[this.userNo].tachogram = this.privtachogram;



    this.gn.priv[this.userNo].settings = this.privsettings;
    this.gn.priv[this.userNo].generalsettings = this.privgeneralsettings;
    this.gn.priv[this.userNo].usersettings = this.privusersettings;
    this.gn.priv[this.userNo].groupspoi = this.privgroupspoi;
    this.gn.priv[this.userNo].vehicles = this.privvehicles;
    this.gn.priv[this.userNo].ounits = this.privounits;
    this.gn.priv[this.userNo].employees = this.privemployees;
    this.gn.priv[this.userNo].worktime = this.privworktime //sett
    this.gn.priv[this.userNo].nonworkingdays = this.privnonworkingdays
    this.gn.priv[this.userNo].alerts = this.privalerts
    this.gn.priv[this.userNo].logsreport = this.privlogsreport
    this.gn.priv[this.userNo].jobs = this.privjobs
    this.gn.priv[this.userNo].armament = this.privarmament

    this.gn.priv[this.userNo].routes = this.privroutes;
    this.gn.priv[this.userNo].routesnew = this.privroutesnew;
    this.gn.priv[this.userNo].routespredefined = this.privroutespredefined;
    this.gn.priv[this.userNo].routessearch = this.privroutessearch;

    this.gn.priv[this.userNo].barcodescanner = this.privbarcodescanner;

    //debugger

    this.gn._Post('/api/gn/savepriv', this.gn.priv[this.userNo], function (_data) {
      _that.navCtrl.pop()
    })
  }
  selectPriv(_txt: any, ev: any) {
    var _ch = ev.value;

    if (_txt == 'live') {
      //this.privlivetracking = _ch;
      this.privlivetracking = _ch
      this.privaddpoi = _ch;
      this.privviewpoi = _ch;
      this.privaddzones = _ch;
      this.privviewzones = _ch;
      this.privlivemoreoptions = _ch;
    }
    if (_txt == 'reports') {
      this.privdashboard = _ch
      this.privoverview = _ch
      this.privshortreport = _ch
      //new
      this.privelectricvehrep = _ch
      this.privvozenparkreport = _ch
      this.privdrivervehicle = _ch
      this.privbaddrivingvehilce = _ch
      this.privtrafficrules = _ch
      this.privinterventionreport = _ch
      this.privmovementsensor = _ch
      this.privtowreport = _ch
      this.privdigalkaanalog = _ch
      this.privsecurityprotocol = _ch
      this.privcbfueladded = _ch
      this.privweaksatellites = _ch
      this.privagrreport = _ch
      this.privtaxi1report = _ch
      this.privtaxi2report = _ch
      this.privspeedlimitbuzzer = _ch
      this.privdraegerdatarep = _ch
      this.privsumdataroutingvehicles = _ch
      this.privsumdataroutingdrivers = _ch
      this.privroutingunvisitedpoi = _ch
      this.privshiftoverview = _ch
      this.privdriverreport = _ch
      this.privdriveranalytics = _ch
      this.privdriverscore = _ch
      this.privcustomizedreport = _ch
      this.privrfiddriver = _ch
      this.privprotocolgenerator = _ch
      this.privgarminmessages = _ch
      this.privgarminstopstatus = _ch

      //end new
      this.privdetailreport = _ch
      this.prividlingreport = _ch
      this.privworktimereport = _ch
      this.privvisitedpoi = _ch
      this.privreconstruction = _ch
      this.privdistance = _ch
      this.privactivity = _ch
      this.privmaxspeed = _ch
      this.privspeedlimit = _ch
      this.privfuelreport = _ch
      this.privfmoverview = _ch
      this.privfmreportcosts = _ch
      this.privfmreportfuel = _ch
      this.privfmreportperformed = _ch
      this.privfmothercosts = _ch
      this.privfmfullreport = _ch
      this.privfmalerttires = _ch
      this.privfmalertservice = _ch
      this.privfmalertreg = _ch
      this.privalarmreport = _ch
      this.privexportpdf = _ch
      this.privexportexcel = _ch
      this.privschedule = _ch
      this.privfuelpulses = _ch
      this.privsecuritystatereport = _ch
      this.privtechmalreport = _ch
      this.privsummdatarouting = _ch
      this.privbeaconreport = _ch
      this.privbluethoottemp = _ch
      this.privsusfueldown = _ch
      this.privtachogram = _ch

      // ova tuka e vo ostanato -- 
      this.privbarcodescanner = _ch
      // ova tuka e vo ostanato -- 
    }
    if (_txt == 'settings') {
      this.privgeneralsettings = _ch
      this.privusersettings = _ch
      this.privgroupspoi = _ch
      this.privvehicles = _ch
      this.privounits = _ch
      this.privemployees = _ch
      this.privworktime = _ch // settings work schedule
      this.privnonworkingdays = _ch
      this.privalerts = _ch
      this.privlogsreport = _ch
      this.privjobs = _ch
      this.privarmament = _ch
    }
    if (_txt == 'routes') {
      this.privroutesnew = _ch
      this.privroutespredefined = _ch
      this.privroutessearch = _ch

    }
  }

}





// WEBPACK FOOTER //
// ./src/pages/settings/usersettings/editpriv.ts